import { PureComponent } from 'react';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';

import {
  COMP_TYPE_DEFAULT,
  VALUE_TYPE_DEFAULT
} from 'legacy/appstore/constants';

import HeaderMapContainer from 'legacy/containers/maps-property-explorer-header';
import CobrandingContainer from 'legacy/containers/property-explorer-cobranding';
import CobrandingFixedHeader from 'legacy/containers/cobranding-fixed-header';
import ValueContainer from 'legacy/containers/property-explorer-value';
import CompsSummarySectionContainer from 'legacy/containers/comps-summary-section';
import GlobalNavContainer from 'legacy/containers/global-nav';
import RentalReportSectionContainer from 'legacy/containers/rental-report-section';
import PropertyDetailsSectionContainer from 'legacy/containers/property-details-section';
import SubjectPhotoCardContainer from 'legacy/containers/subject-photo-card';
import CompsButtonsContainer from 'legacy/containers/comps-buttons';

import PropertyExplorerCharts from 'legacy/components/PropertyExplorerCharts';
import PropertyTransactionHistorySection from 'legacy/components/PropertyTransactionHistorySection';
import PropertyExplorerStaticPropertyDetails from 'legacy/components/PropertyExplorerStaticPropertyDetails';
import PropertyExplorerSection from 'legacy/components/PropertyExplorerSection';
import Loading from 'legacy/components/generic/Loading';
import { MlsDisclaimerFooter } from 'legacy/containers/mls-disclaimer';
import { PropertyExplorerPage as theme } from 'legacy/css-modules';
import HC_CONSTANTS from 'HC_CONSTANTS';

const { TERMS_OF_USE_URL, PRIVACY_POLICY_URL } = HC_CONSTANTS;
const CONTAINER_ID = 'property-explorer-container';
const CONTENT_TOP_ID = 'content-top';

class PropertyExplorerPage extends PureComponent {
  render() {
    const {
      subjectAdjusted,
      photos,
      isAvmHcEmpty,
      showCobranding,
      showCobrandingFixedHeader,
      reportIsLoadedHc,
      isReadOnly,
      isMobile,
      reportIsLoaded,
      onClose,
      commentModal,
      shareModal,
      commentValue,
      isEffectiveDateReport
    } = this.props;

    const isReportLoaded = isAvmHcEmpty
      ? reportIsLoaded && reportIsLoadedHc
      : reportIsLoaded;

    return (
      <>
        <GlobalNavContainer key="top-nav" propertySearch />
        <div
          key="page-wrapper"
          id={CONTAINER_ID}
          className={theme['page-wrapper']}
        >
          <div
            key="property-explorer-page"
            className={classNames(
              theme['property-explorer-page'],
              'property-explorer-page'
            )}
          >
            {showCobranding && (
              <div className={theme['cobranding-section']}>
                <CobrandingContainer />
              </div>
            )}
            <div
              id={CONTENT_TOP_ID}
              className={classNames(theme['top-map-section'], {
                [theme['without-photo']]: !photos.length
              })}
            >
              <div
                className={theme['top-map-section--map']}
                data-hc-name="main-map-section"
              >
                <HeaderMapContainer />
                <CompsButtonsContainer />
              </div>
              <SubjectPhotoCardContainer className={theme.SubjectPhotoCard} />
            </div>
            <PropertyExplorerSection>
              <div
                className={classNames(theme['static-details-value-section'])}
              >
                <div className={theme['value-section']}>
                  <Loading
                    className={theme.ValueLoading}
                    loading={!isReportLoaded}
                  >
                    <ValueContainer valueType={VALUE_TYPE_DEFAULT} />
                  </Loading>
                </div>
                <hr
                  className={classNames(
                    theme['show-mobile'],
                    theme.PageDividerInSection
                  )}
                />
                <div
                  className={classNames(
                    theme['static-details-section'],
                    'flex-item'
                  )}
                >
                  {
                    /* Hide until it's loaded */
                    !isEmpty(subjectAdjusted) && (
                      <PropertyExplorerStaticPropertyDetails
                        limitedReport={!isReportLoaded ? false : isAvmHcEmpty}
                        isReadOnly={isReadOnly}
                        property={subjectAdjusted}
                        onClose={onClose}
                        commentModal={commentModal}
                        shareModal={shareModal}
                        commentValue={commentValue}
                        showAllDetails={reportIsLoadedHc}
                      />
                    )
                  }
                </div>
              </div>
            </PropertyExplorerSection>
            <hr />
            <PropertyDetailsSectionContainer addressId="subject" />
            <hr />
            <PropertyTransactionHistorySection addressId="subject" />
            <hr />

            <PropertyExplorerSection printPageBreak>
              <CompsSummarySectionContainer compType={COMP_TYPE_DEFAULT} />
            </PropertyExplorerSection>
            <hr />
            {!isEffectiveDateReport && (
              <>
                <PropertyExplorerSection printPageBreak>
                  <RentalReportSectionContainer />
                </PropertyExplorerSection>
                <hr />
              </>
            )}
            <PropertyExplorerSection printPageBreak>
              <PropertyExplorerCharts isMobile={isMobile} />
            </PropertyExplorerSection>
          </div>
          <section className={theme.Legal}>
            <small>
              <a target="_blank" rel="noreferrer" href={TERMS_OF_USE_URL}>
                Terms of Use
              </a>{' '}
              |{' '}
              <a target="_blank" rel="noreferrer" href={PRIVACY_POLICY_URL}>
                Privacy Policy
              </a>
            </small>
            <MlsDisclaimerFooter />
          </section>
        </div>
        {!!showCobrandingFixedHeader && (
          <CobrandingFixedHeader
            key="cobranding-header"
            containerId={CONTAINER_ID}
            contentTopId={CONTENT_TOP_ID}
          />
        )}
      </>
    );
  }
}

export default PropertyExplorerPage;
